import { CHART_ELEMENT_ID } from 'finviz-charts/app/constants/common'
import { Suspense } from 'react'
import ReactDOM from 'react-dom'
import ReactDOMClient from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { NotificationWrapper } from '../../main/components/notification'
import { SpecificChartFunctionality } from '../../main/constants'
import { ResizableChartLayoutWithGlobalState } from '../shared/components/ResizableChartLayoutWithGlobalState'
import { ready } from '../shared/ready'
import { parseInitData } from '../shared/utils'
import ForexActionCreators from './actions/forexActionCreators'
import './forex'
import { ForexCharts } from './forex'
import { ForexTileMap } from './types'

window['FinvizInitForexCharts'] = function () {
  const forexEl = document.getElementById('forex')
  const dataEl = document.getElementById('forex-init-data')
  if (!forexEl || !dataEl) return

  try {
    const initData = parseInitData<ForexTileMap>('forex-init-data')
    ForexActionCreators.update(initData)
  } catch {
    return
  }

  const root = ReactDOMClient.createRoot(forexEl)
  root.render(
    <BrowserRouter>
      <ForexCharts />
    </BrowserRouter>
  )
}

ready(function () {
  const forexEl = document.getElementById('forex')
  const chartEl = document.getElementById(CHART_ELEMENT_ID)
  const dataEl = document.getElementById('forex-init-data')
  if (!forexEl || !chartEl || !dataEl || !window.globalChartConfig) return

  try {
    const initData = parseInitData<ForexTileMap>('forex-init-data')
    ForexActionCreators.update(initData)
  } catch {
    return
  }

  const root = ReactDOMClient.createRoot(chartEl)
  root.render(
    <BrowserRouter>
      <NotificationWrapper>
        {ReactDOM.createPortal(<ForexCharts />, forexEl)}
        <Suspense fallback={null}>
          <ResizableChartLayoutWithGlobalState specificChartFunctionality={SpecificChartFunctionality.forexPage} />
        </Suspense>
      </NotificationWrapper>
    </BrowserRouter>
  )
})
